export default __webpack_public_path__ + "static/media/report@2x.53e80e87.png";